/**
 * Telegram WebApp utilities
 */

import { openLink, hapticFeedback as sdkHaptic } from '@telegram-apps/sdk';

export function openExternalLink(url: string) {
  if (openLink.isAvailable()) {
    openLink(url);
  } else {
    window.open(url, '_blank');
  }
}

export function hapticFeedback(type: 'light' | 'medium' | 'heavy' | 'success' | 'warning' | 'error' = 'light') {
  try {
    if (type === 'success' || type === 'warning' || type === 'error') {
      if (sdkHaptic.notificationOccurred.isAvailable()) {
        sdkHaptic.notificationOccurred(type);
      }
    } else {
      if (sdkHaptic.impactOccurred.isAvailable()) {
        sdkHaptic.impactOccurred(type);
      }
    }
  } catch {
    // Haptic feedback not available
  }
}
